const paymentState = {
    addressId: 0,
    withStates: null,
    withZip: null,
    vatRate: 0,
    vatIsReverseCharge: 0,
    showVatIdField: false,
    currencyCode: "USD",
    prices: {
        creditsWeb: 0,
        creditsDecode: 0,
        creditsStolen: 0,
        creditsOemVinLookup: 0,
        creditsVehicleMarketValue: 0,
        fixedPrice: 900
    },
    lastPrices: {
        creditsWeb: 0,
        creditsDecode: 0,
        creditsStolen: 0,
        creditsOemVinLookup: 0,
        creditsVehicleMarketValue: 0,
        fixedPrice: 0
    },
    whitelist: {
        creditsWeb: false,
        creditsDecode: false,
        creditsStolen: false,
        creditsOemVinLookup: false,
        creditsVehicleMarketValue: false,
        fixedPrice: false,
        email: false,
        country: true,
        state: false,
        first_name: true,
        last_name: true,
        organization: true,
        vat_id: false,
        url: true,
        street: true,
        zip: true,
        city: true,

        agreed_tac: true,

        virtualHasCredits: false,
    },
    noInputs: false,
    creditPacksSelected: {},
    creditsSelected: {},
    isPricingPage: false
};
export default paymentState;
